import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constants } from 'src/app/constants';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { InvestigationService } from 'src/app/service/investigation.service';
import { DatePipe } from '@angular/common';
import { FormControl } from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-edit-investigation',
  templateUrl: './edit-investigation.component.html',
  styleUrls: ['./edit-investigation.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None 
})
export class EditInvestigationComponent implements OnInit {

  dateOfTrigger: any;
  domicile: any;
  resUser: any;
  planMaxload: any;
  owkMaxload: any;
  actualInvestigation: any;
  rootCause: any;
  loadNumber: any;
  route: any;
  blowouts: any;
  owkBlowouts: any;
  planMaxloadActualDate: any;
  owkMaxloadActualDate: any;
  actualCountermeasureComplete: any;
  countermeasure: any;
  heading: any;
  errormsg: string;
  eventType: any;
  plannedBlowoutDrpDwn;
  owkBlowoutDropDown;
  resUserDropDown;
  rootCauseDrpDwn;
  plannedBlowout: any;
  CountermeasureDropDown;
  yesNoDropDown;
  planMaxloadTargetDate: any;
  oWKMaxloadTargetDate: any;
  actualInvestigationComplete: any;

  countermeasureFilterCtrl: FormControl = new FormControl();
  filteredCountermeasures: ReplaySubject<any[]> = new ReplaySubject(1);
  rootCauseFilterCtrl: FormControl = new FormControl();
  filteredRootCauses: ReplaySubject<any[]> = new ReplaySubject(1);
  resUserFilterCtrl: FormControl = new FormControl();
  filteredResUsers: ReplaySubject<any[]> = new ReplaySubject(1);
  date_const='MM-dd-yyyy'
  year_const='yyyy-MM-dd'

  constructor(public dialogRef: MatDialogRef<EditInvestigationComponent>, private readonly constants: Constants, private readonly ngxUiLoaderService: NgxUiLoaderService,
    @Inject(MAT_DIALOG_DATA) public dataStore: any, private readonly investigService: InvestigationService, public datepipe: DatePipe, private readonly investigationService: InvestigationService) { }

  ngOnInit(): void {
    this.yesNoDropDown = [{ label: "---", value: null }, { label: "Yes", value: 1 }, { label: "No", value: 0 }]
    this.plannedBlowout = this.dataStore.plannedBlowout
    this.owkBlowouts = this.dataStore.owkBlowouts
    this.heading = this.dataStore.header;
    this.resUserDropDown = this.dataStore.usersDrpDown;
    this.CountermeasureDropDown = this.dataStore.counterMeasureDropDown;
    this.dateOfTrigger = this.dataStore.dateOfTrigger;
    this.domicile = this.dataStore.domicile
    this.resUser = this.resUserDropDown?.find(x => (x.value)?.toString().toLowerCase() == (this.dataStore.resUser)?.toString().toLowerCase()) // NOSONAR
    this.loadNumber = this.dataStore.loadNumber
    this.route = this.dataStore.route
    this.blowouts = this.dataStore.blowouts
    this.planMaxload = this.dataStore.planMaxload
    this.owkMaxload = this.dataStore.owkMaxload
    this.countermeasure = this.CountermeasureDropDown?.find(x => x.value == this.dataStore.countermeasure) // NOSONAR

    this.planMaxloadTargetDate = this.dataStore.planMaxloadTargetDate
    this.oWKMaxloadTargetDate = this.dataStore.oWKMaxloadTargetDate
    this.actualInvestigationComplete = this.datepipe.transform(this.dataStore.actualInvestigationComplete, this.year_const)//this.dataStore.actualCountermeasureComplete
    this.planMaxloadActualDate = this.datepipe.transform(this.dataStore.planMaxloadActualDate, this.year_const)//this.dataStore.planMaxloadActualDate
    this.owkMaxloadActualDate = this.datepipe.transform(this.dataStore.oWKMaxloadActualDate, this.year_const)//this.dataStore.owkMaxloadActualDate
    this.actualCountermeasureComplete = this.datepipe.transform(this.dataStore.actualCountermeasureComplete, this.year_const)

    this.filteredCountermeasures.next(this.CountermeasureDropDown?.slice());
    this.filteredResUsers.next(this.resUserDropDown?.slice() || []);

    this.resUserFilterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(search => search ? this.filterResUsers(search) : this.resUserDropDown?.slice() || [])
      )
      .subscribe(filtered => {
        this.filteredResUsers.next(filtered);
      });


    this.countermeasureFilterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(search => search ? this.filterCountermeasures(search) : this.CountermeasureDropDown?.slice())
      )
      .subscribe(filtered => {
        this.filteredCountermeasures.next(filtered);
      });



    this.rootCauseFilterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(search => search ? this.filterRootCauses(search) : this.rootCauseDrpDwn?.slice() || [])
      )
      .subscribe(filtered => {
        this.filteredRootCauses.next(filtered);
      });

    this.callingRootCause();
  }

  private filterCountermeasures(search: string): any[] {
    const lowerSearch = search.toLowerCase();
    return this.CountermeasureDropDown?.filter(option =>
      option.label.toLowerCase().includes(lowerSearch));
  }

  private filterRootCauses(search: string): any[] {
    const lowerSearch = search.toLowerCase();
    return this.rootCauseDrpDwn?.filter(option => option.label.toLowerCase().includes(lowerSearch)) || [];
  }

  private filterResUsers(search: string): any[] {
    const lowerSearch = search.toLowerCase();
    return this.resUserDropDown?.filter(option => option.label.toLowerCase().includes(lowerSearch)) || [];
  }




  async callingRootCause() {
    console.info(this.plannedBlowout + "++" + this.owkBlowouts)
    if ((this.plannedBlowout == 1 || this.plannedBlowout == 0) && (this.owkBlowouts == 1 || this.owkBlowouts == 0)) { // NOSONAR
      await this.investigationService.rootcauseDropDown(this.plannedBlowout, this.owkBlowouts).then(x => {

        if (x && x.length > 0) {
          this.rootCauseDrpDwn = [];
          x.forEach(element => {
            this.rootCauseDrpDwn.push({ label: element.description, value: element.rootCauseId })
          });
          this.filteredRootCauses.next(this.rootCauseDrpDwn?.slice() || []);
        }
      })
      this.rootCause = this.rootCauseDrpDwn?.find(x => x.value == this.dataStore.rootCauseId) // NOSONAR

    }
  }

  saveAPICall() {
    this.errormsg = ""
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    const updateObject = {
      investigationId: this.dataStore.investigationId,
      responsibleUserId: this.resUser?.value,
      plannedBlowout: this.plannedBlowout == 1 || this.plannedBlowout == 0 ? this.plannedBlowout : null, // NOSONAR
      owkBlowout: this.owkBlowouts == 1 || this.owkBlowouts == 0 ? this.owkBlowouts : null, // NOSONAR
      rootCauseId: this.rootCause?.value,
      counterMeasureId: this.countermeasure?.value,
      counterMeasureActualDate: this.datepipe.transform(this.actualCountermeasureComplete, this.date_const),//this.actualCountermeasureComplete,
      actualResultDate: this.datepipe.transform(this.planMaxloadActualDate, this.date_const),//this.planMaxloadActualDate,
      actualMaxLoadDate: this.datepipe.transform(this.owkMaxloadActualDate, this.date_const),//this.owkMaxloadActualDate,
      actualInvestigationDate: this.datepipe.transform(this.actualInvestigationComplete, this.date_const)//this.dataStore.actualCountermeasureComplete
    }
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)

    this.investigService.updateinvestigation(updateObject).subscribe(
      response => {
        if (response == "Success") { // NOSONAR
          this.dialogRef.close({
            event: "SaveEvent",
            eventType: this.eventType,
          });
        } else {
          this.showError(this.constants.APIErrorMessage);
        }
      }, error => {
        console.info(error)
        this.showError(this.constants.APIErrorMessage);
      });


  }
  close(): void {
    this.dialogRef.close(
      { event: 'CloseEvent' }
    );
  }
  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  showError(message) {
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
    this.errormsg = message;
    setTimeout(() => {
      this.errormsg = ""
    }, this.constants.notificationMessageTimeShort);
  }
  public saveClick() {
    {
      this.saveAPICall();
    }
  }

}
